export let EnergyClass = /*#__PURE__*/function (EnergyClass) {
  EnergyClass["A"] = "A";
  EnergyClass["A1"] = "A1";
  EnergyClass["A2"] = "A2";
  EnergyClass["A3"] = "A3";
  EnergyClass["A4"] = "A4";
  EnergyClass["B"] = "B";
  EnergyClass["C"] = "C";
  EnergyClass["D"] = "D";
  EnergyClass["E"] = "E";
  EnergyClass["F"] = "F";
  EnergyClass["G"] = "G";
  return EnergyClass;
}({});
//# sourceMappingURL=constants.js.map